import { Component, OnInit } from '@angular/core';
import {Blog} from '../../../../model/Blog';
import {BlogService} from '../../../../service/blog.service';

@Component({
  selector: 'app-adm-blog',
  templateUrl: './adm-blog.component.html',
  styleUrls: ['./adm-blog.component.scss']
})
export class AdmBlogComponent implements OnInit {
  blogList: Blog[];
  loading: boolean;

  constructor(
    private blogService: BlogService
  ) { }

  ngOnInit() {
    this.getAllBlogs();
  }

  getAllBlogs() {
    // this.spinnerService.show();
    this.loading = true;
    const x = this.blogService.getBlogs();
    x.snapshotChanges().subscribe(
      (blog) => {
        this.loading = false;
        // this.spinnerService.hide();
        this.blogList = [];
        blog.forEach((element) => {
          const y = element.payload.toJSON();
          y['$key'] = element.key;
          this.blogList.push(y as Blog);
        });
      },
      (err) => {
        //  this.toastrService.error('Error while fetching Blogs', err);
      }
    );
  }

}
